<template>
  <div class="number--wrapper">
    <div class="number--types">
      <v-select
          v-model="numberSelect"
          :hint="numberSelect.name"
          :items="numberItems"
          item-text="name"
          item-value="value"
          label="Choose the type of filtering"
          @change="selectType"
      ></v-select>
    </div>
    <div
        class="number--inputs"
        :class="[{'el3':numberSelect === 3}]"
    >
      <div class="input-wr">
        <v-text-field
            :label="numberSelect === 3 ? 'From' : 'Value'"
            v-model="numberFrom"
            type="number"
        ></v-text-field>
      </div>
      <div
          class="input-wr"
          v-if="numberSelect === 3"
      >
        <v-text-field
            label="To"
            v-model="numberTo"
            type="number"
        ></v-text-field>
      </div>
      <div class="btn-wr">
        <v-btn
            :disabled="!numberValue || validateFromTo"
            text
            @click="numberSubmit"
        >
          OK
        </v-btn>
      </div>
    </div>
    <div class="error"
         v-if="validateFromTo"
    >
      The "From" value must not be greater than the "To" value.
    </div>
  </div>
</template>

<script>
export default {
	name: "TypeNumber",
	props: {
		condition: String,
		filterName: String,
	},
	data() {
		return {
			numberSelect: 1,
			numberItems: [
				{ name: 'Less than value (<=)', value: 1 },
				{ name: 'Greater than value (>=)', value: 2 },
				{ name: 'Between values (-)', value: 3 },
				{ name: 'Exact value (=)', value: 4 },
			],
			numberFrom: null,
			numberTo: null,
		};
	},
	computed: {
		numberValue() {
			const from = this.numberFrom;
			const to = this.numberTo;
			const type = this.numberSelect;

			if (type === 3) {
				if (!!from && !!to) {
					return true;
				} 
				return false;
        
			} 
			if (from) {
				return true;
			} 
			return false;
      
		},
		validateFromTo() {
			const from = this.numberFrom;
			const to = this.numberTo;
			if (!!from && !!to) {
				if (Number(from) > Number(to)) {
					return true;
				} 
				return false;
        
			} 
			return false;
      
		},
	},
	methods: {
		numberSubmit() {
			const name = this.filterName;
			const type = this.numberSelect;
			let value = Number(this.numberFrom);
			if (type === 3) {
				value = [ Number(this.numberFrom), Number(this.numberTo) ];
			}
			const values = { name, type, value };

			this.$emit('updateNumber', values);
		},
		selectType() {
			this.numberTo = null;
		},
	},
	watch: {
		condition(val, oldVal) {
			if (val !== oldVal) {
				this.numberSelect = { name: 'Less than value (<=)', value: 1 };
				this.numberFrom = null;
				this.numberTo = null;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.number--wrapper {
  font-size: 14px;
  .number--types {
    .v-text-field {
      padding-top: 0;
      margin-top: 0;
    }
  }
  .number--inputs {
    display: grid;
    grid-template-columns: 1fr 64px;
    grid-gap: 10px;
    &.el3 {
      grid-template-columns: 1fr 1fr 64px;
    }
    .input-wr {}
    .btn-wr {
      display: flex;
      align-items: center;
    }
  }
  .error {
    font-size: 14px;
    padding: 5px 7px;
    border-radius: 4px;
    white-space: normal;
  }
}
</style>
